import { PipesModule } from 'src/app/pipes/pipes.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { IonicModule } from '@ionic/angular';

import { TicketComponent } from './components/ticket/ticket.component';
import { TicketsListSkeletonComponent } from './components/tickets-list-skeleton/tickets-list-skeleton.component';
import { TicketsPage } from './tickets.page';

const routes: Routes = [
  {
    path: '',
    component: TicketsPage,
  },
];

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes), PipesModule],
  declarations: [TicketsPage, TicketsListSkeletonComponent, TicketComponent],
  providers: [Geolocation],
})
export class TicketsPageModule {}
